import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { MonitorEventsSuccessResponse } from "./api-response/MonitorEventsSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import * as queryString from "query-string";
import { map } from "rxjs/operators";

export interface MonitorEventListFilters {
  name?: string;
  email?: string;
  userId?: string;
  fromDate?: string;
  toDate?: string;
  eventName?: string;
}

export class ApiMonitorEvent {
  constructor(private apiEndpoint: string) {}

  list(
    token: string,
    organization: string,
    filters: MonitorEventListFilters,
    nextPageUrl?: string
  ): Observable<MonitorEventsSuccessResponse> {
    let url: string;

    let filtersStr = "";
    if (filters) {
      filtersStr = queryString.stringify(filters, { arrayFormat: "bracket" });
    }

    if (nextPageUrl) {
      url = nextPageUrl;
    } else {
      url = `${this.apiEndpoint}/organizations/${organization}/monitor-event-search?${filtersStr}`;
    }

    return ajax({
      method: "GET",
      url,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
